// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-header {
  background-color: var(--admin-primary-color);
  height: var(--admin-header-height);
}
.admin-header .header-bottom-line {
  background: linear-gradient(102.62deg, rgba(137, 32, 254, 0) 10.31%, rgba(249, 40, 198, 0.54) 49.65%, #ff7e5b 93.66%);
  height: 4px;
}

.admin-navbar {
  background-color: var(--admin-nav-bg);
  max-width: 230px;
}
.admin-navbar .nav-items {
  background-color: transparent;
  color: var(--admin-primary-color);
  text-decoration: none;
}
.admin-navbar .nav-items:hover {
  background-color: var(--admin-nav-hover-bg);
  color: var(--white);
}
.admin-navbar .nav-items.selected {
  background-color: var(--admin-primary-color);
  color: var(--white);
}
@media screen and (max-width: 768px) {
  .admin-navbar {
    max-width: 60px;
  }
  .admin-navbar .nav-items span {
    display: none;
  }
}

.main-wrapper {
  height: calc(100vh - var(--admin-header-height));
  background-color: var(--admin-main-bg);
}
.main-wrapper .main-top-container {
  margin-top: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/Admin/AdminTemplate/style.scss"],"names":[],"mappings":"AAAA;EACE,4CAAA;EACA,kCAAA;AACF;AACE;EACE,qHAAA;EAMA,WAAA;AAJJ;;AAQA;EACE,qCAAA;EACA,gBAAA;AALF;AAOE;EACE,6BAAA;EACA,iCAAA;EACA,qBAAA;AALJ;AAOI;EACE,2CAAA;EACA,mBAAA;AALN;AAQI;EACE,4CAAA;EACA,mBAAA;AANN;AAUE;EApBF;IAqBI,eAAA;EAPF;EASE;IACE,aAAA;EAPJ;AACF;;AAWA;EACE,gDAAA;EACA,sCAAA;AARF;AAUE;EACE,gBAAA;AARJ","sourcesContent":[".admin-header {\n  background-color: var(--admin-primary-color);\n  height: var(--admin-header-height);\n\n  .header-bottom-line {\n    background: linear-gradient(\n      102.62deg,\n      rgba(137, 32, 254, 0) 10.31%,\n      rgba(249, 40, 198, 0.54) 49.65%,\n      #ff7e5b 93.66%\n    );\n    height: 4px;\n  }\n}\n\n.admin-navbar {\n  background-color: var(--admin-nav-bg);\n  max-width: 230px;\n\n  .nav-items {\n    background-color: transparent;\n    color: var(--admin-primary-color);\n    text-decoration: none;\n\n    &:hover {\n      background-color: var(--admin-nav-hover-bg);\n      color: var(--white);\n    }\n\n    &.selected {\n      background-color: var(--admin-primary-color);\n      color: var(--white);\n    }\n  }\n\n  @media screen and (max-width: 768px) {\n    max-width: 60px;\n\n    .nav-items span {\n      display: none;\n    }\n  }\n}\n\n.main-wrapper {\n  height: calc(100vh - var(--admin-header-height));\n  background-color: var(--admin-main-bg);\n\n  .main-top-container {\n    margin-top: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
